import { createApiAction, createInfoApiAction, createPaginationAction } from './common'

export const searchUser = createApiAction('searchUser', (format, count) => ({ format, count }))
export const getUserList = createPaginationAction('getUserList')
export const getUserInfo = createInfoApiAction('getUserInfo', (id) => ({ id }))
export const updateUserInfo = createInfoApiAction('updateUserInfo', (id, form) => ({ id, form }))
export const changePassword = createInfoApiAction('changePassword', (id, data) => ({ id, data }))
